import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from 'assets/img/header/homeLogo.png';
import _imports_1 from 'assets/img/footer/phone.png';
import _imports_2 from 'assets/img/footer/mail.png';
import _imports_3 from 'assets/img/footer/location.png';
import _imports_4 from 'assets/img/footer/address.png';
import _imports_5 from 'assets/img/footer/qr.png';
import _imports_6 from 'assets/img/footer/icon.png';
const _withScopeId = n => (_pushScopeId("data-v-429f7df5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
})], -1));
const _hoisted_4 = {
  class: "us"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "cn"
}, "关于我们"), /*#__PURE__*/_createElementVNode("div", {
  class: "en"
}, "about us")], -1));
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"us\" data-v-429f7df5><div class=\"title\" data-v-429f7df5><div class=\"cn\" data-v-429f7df5>联系我们</div><div class=\"en\" data-v-429f7df5>contact us</div></div><a class=\"item\" href=\"tel:051882096658\" data-v-429f7df5><img src=\"" + _imports_1 + "\" class=\"icon\" data-v-429f7df5><div data-v-429f7df5>0518-82096658</div></a><a href=\"mailto:jsxwg168@163.com\" class=\"item\" data-v-429f7df5><img src=\"" + _imports_2 + "\" class=\"icon\" data-v-429f7df5><div data-v-429f7df5>jsxwg168@163.com</div></a></div><div class=\"us\" data-v-429f7df5><div class=\"title\" data-v-429f7df5><div class=\"cn\" data-v-429f7df5>找到我们</div><div class=\"en\" data-v-429f7df5>find us</div></div><div class=\"item\" data-v-429f7df5><img src=\"" + _imports_3 + "\" class=\"icon\" data-v-429f7df5><div data-v-429f7df5>连云港市赣榆经济开发区和安中小企业园2号楼四楼</div></div><a href=\"https://amap.com/place/B0FFHUE6ML\" class=\"item\" target=\"_blank\" data-v-429f7df5><img src=\"" + _imports_4 + "\" class=\"address\" data-v-429f7df5></a></div><div class=\"us\" data-v-429f7df5><div class=\"title\" data-v-429f7df5><div class=\"cn\" data-v-429f7df5>关注我们</div><div class=\"en\" data-v-429f7df5>Follow us</div></div><img src=\"" + _imports_5 + "\" class=\"code\" data-v-429f7df5><div class=\"tip\" data-v-429f7df5>扫一扫 关注我们</div></div>", 3);
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "floor"
}, [/*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" Copyright © 2021 江苏新万格医疗科技有限公司  "), /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://beian.miit.gov.cn"
}, "苏ICP备2021046878号")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
}), /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32072102010234"
}, " 苏公网安备 32072102010234号 ")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_router_link, {
    to: "/home",
    class: "item"
  }, {
    default: _withCtx(() => [_createTextVNode("公司介绍")]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/home?type=history",
    class: "item"
  }, {
    default: _withCtx(() => [_createTextVNode("发展历程")]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/position",
    class: "item"
  }, {
    default: _withCtx(() => [_createTextVNode("加入我们")]),
    _: 1
  })]), _hoisted_6]), _hoisted_9]);
}